import localForage from 'localforage';
import { extendPrototype as extendSet }  from 'localforage-setitems';
import { extendPrototype as extendGet } from 'localforage-getitems';
import { extendPrototype as startsWithExtend } from 'localforage-startswith';

extendSet(localForage);
extendGet(localForage);
startsWithExtend(localForage);

export default {
    install (Vue, options) {
        Vue.prototype.$vlf = function(storeName) {
            return localForage.createInstance({
                name: 'anm22_world',
                storeName: storeName
            });
        };
        Vue.prototype.$vlfClearDb = function() {
            console.log('clearing anm22_world db');
            return localForage.dropInstance({
                name: 'anm22_world'
            });
        }
    }
}